export default "__VITE_ASSET__VJjfC_6J__"